import React, { useState } from 'react';
import Chart from 'react-apexcharts';
import clsx from "clsx";

export default function LineChart(props) {
    const [state, setState] = useState(
        {
            series: props.series,
            options: {
                chart: {
                    type: 'line',
                    height: 350,
                    stacked: true,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: false
                    },
                },
                colors: [clsx(props.color1), clsx(props.color2)],
                dataLabels: {
                    enabled: true,
                },

                stroke: {
                    curve: 'straight'
                },
                title: {
                    text: props.title,
                    align: 'centre'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                // markers: {
                //     size: 1
                // },
                xaxis: {
                    categories: props.categories_X,
                    title: {
                        text: props.title_X
                    }
                },
                yaxis: props.categories_Y ? {
                    forceNiceScale: true,
                    max: 100,
                    min: 50,
                    labels: {
                        formatter: (value) => value.toFixed(0) + '%',
                    },
                } :
                    {
                        title: {
                            text: props.title_Y
                        }
                    },
                legend: {
                    position: 'bottom',
                    offsetX: 10
                },
            },
        }
    )
    return (
        <>
            <Chart
                options={state.options}
                series={state.series}
                type="line"
                // width={1200}
                height={320}
            />
        </>
    );
}

